import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FloatingTooltip } from '../../Floating'
import { Switch } from '../../Switch'
import Text from '../../Text'

import * as styles from './FilterToggle.module.css'

function FilterToggle({
  className,
  disabled,
  filter: { title },
  isOn,
  qaName,
  onClick,
}) {
  const { t } = useTranslation()

  function handleChange(isOn) {
    onClick(isOn)
  }

  const filterClassName = classNames(styles.filter, className)

  return (
    <div className={filterClassName}>
      <FloatingTooltip content={t(title)} disabled={disabled}>
        <Text isSecondary disabled={disabled}>
          {t(title)}
        </Text>
      </FloatingTooltip>
      <Switch
        className={styles.switch}
        disabled={disabled}
        qaName={qaName}
        value={!!isOn}
        onChange={handleChange}
      />
    </div>
  )
}

export default FilterToggle
